import * as React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Typography } from '@material-ui/core';
import { fetchNotificationTypes } from '../../store/Notifications/NotificationsActions';
import { ApplicationState } from '../../store';
import { LoadingPanel } from '../LoadingPanel';

interface Props {
  onSelect: (notification: string) => void;
}

const NotificationTypesListBox: React.FC<Props> = ({
  onSelect,
}): React.ReactElement => {
  const [selectedNotification, setSelectedNotification] = React.useState('');
  const handleClick = (notification: string) => () => {
    setSelectedNotification(notification);
    onSelect(notification);
  };
  const loading: boolean = useSelector(
    (state: ApplicationState) =>
      state.notificationsReducer.isFetchingNotificationTypes
  );
  const dispatch: Dispatch<any> = useDispatch();
  const notificationTypes: string[] = useSelector(
    (state: ApplicationState) => state.notificationsReducer.notificationTypes
  );

  useEffect((): ReturnType<React.EffectCallback> => {
    fetchNotificationTypes(dispatch);
    return (): void => {};
  }, []);

  return (
    <List
      sx={{
        width: '100%',
        height: 400,
        maxWidth: 360,
        bgcolor: 'background.paper',
        overflow: 'auto',
      }}
    >
      {loading && LoadingPanel}
      {notificationTypes?.map(item => (
        <ListItem
          key={item}
          secondaryAction={
            <IconButton edge="end">
              <KeyboardArrowRightIcon />
            </IconButton>
          }
          disablePadding
        >
          <ListItemButton
            selected={selectedNotification === item}
            role={undefined}
            onClick={handleClick(item)}
            dense
          >
            <ListItemText
              primary={<Typography style={{ fontSize: 18 }}>{item}</Typography>}
            />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
};

export default NotificationTypesListBox;
